import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

const LotteryConfirmDialog = ({ open, onClose, onLottery, loading }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle variant='h4'>Επιβεβαίωση Κλήρωσης</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Είστε σίγουροι ότι θέλετε να προχωρήσετε στη διενέργεια κλήρωσης;
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Άκυρο</Button>
        <Button variant="contained" color="primary" onClick={onLottery} disabled={loading}
        >
          {loading ? <CircularProgress size={22} /> : "Επιβεβαίωση"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LotteryConfirmDialog;
